import { checkInputData, updateAccountDetails, resetMessages, splitName } from './utils';

if (!customElements.get('account-details-form')) {
  class accountDetailsForm extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    async init() {
      this.addEventListener('submit', this.updateAccountDetails);
      const inputs = this.querySelectorAll('input');
      const fullnameInput = document.querySelector('[data-fullname-input]');
      const emailInput = document.querySelector('[data-email-input]');
      const phoneInput = document.querySelector('[data-phone-input]');

      inputs.forEach(input => {
        input.addEventListener('focus', resetMessages);
      });
      fullnameInput?.addEventListener('change', (e) => {
        splitName(e.target.value);
        if (e.target.value.length > 2) this.isValidInput(true, e.target);
        else this.isValidInput(false, e.target);
      })
      emailInput?.addEventListener('change', (e) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValid = emailRegex.test(e.target.value);
        this.isValidInput(isValid, e.target);
      });


      phoneInput?.addEventListener('change', (e) => {
        const phoneRegex = /^[+\s\d\-()]{8,}$/;
        const isValid = phoneRegex.test(e.target.value);
        this.isValidInput(isValid, e.target);
      });
    }

    async updateAccountDetails(e) {
      const customer = window.customer;
      if (!customer) return;

      const form = e.srcElement;
      const submitButton = form.querySelector('button[type="submit"]');
      const formData = new FormData(form, submitButton);

      const { errors, data } = await checkInputData(formData, customer);
      if (errors.length) {
        errors.forEach(error => {
          document.querySelector(`[data-form-status="${error}"]`).classList.remove('hidden');
        });
        return;
      }
      // API call to update customer
      if (!data || !data.id && !data.firstName) {
        console.log('🚀 ~ error:', 'No data to update');
        document.querySelector('[data-form-status="error"]').classList.remove('hidden');
        return;
      }
      const status = await updateAccountDetails(data);
      if (status) this.updateWelcomeMessage(data)
    }

    isValidInput(isValid, input) {
      let checkmark = input.closest('div').querySelector('.checkmark');

      if (!checkmark) {
        checkmark = document.createElement('div');
        checkmark.className = 'checkmark absolute right-3 top-1/2 -translate-y-1/2 hidden text-success';
        checkmark.innerHTML = `
          <svg class="w-4 h-4" width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;
        input.parentElement.style.position = 'relative';
        input.parentElement.appendChild(checkmark);
      }

      if (isValid) {
        checkmark.classList.remove('hidden');
        input.classList.remove('border-error');
        input.classList.add('border-success');
      } else {
        checkmark.classList.add('hidden');
        input.classList.remove('border-success');
        input.classList.add('border-error');
      }
    }

    updateWelcomeMessage(data) {
      document.querySelector('[data-form-status="success"]')?.classList.remove('hidden');
      const welcomeMessage = document.querySelector('.welcome-message');
      if (!welcomeMessage) return;
      let ts = welcomeMessage.getAttribute('data-greeting-ts');
      if (!ts) return;
      ts = ts.replace('{{ customerName }}', data.firstName + ' ' + data.lastName);
      welcomeMessage.innerText = ts;
    }

  }

  customElements.define('account-details-form', accountDetailsForm);
}